import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoPipe } from '@ngneat/transloco';
import { FeedbackService } from 'app/shared/services/feedback.service';

@Component({
  selector: 'app-feedback-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TranslocoPipe,
  ],
  template: `
    <h2 mat-dialog-title class="flex items-center gap-2">
      <mat-icon>feedback</mat-icon>
      {{ 'feedbackDialog.title' | transloco }}
    </h2>

    <mat-dialog-content>
      @if (!submitted) {
        <p class="text-secondary text-sm mb-4">
          {{ 'feedbackDialog.intro' | transloco }}
        </p>

        <mat-form-field class="w-full">
          <mat-label>{{ 'feedbackDialog.type' | transloco }}</mat-label>
          <mat-select [(ngModel)]="typeFeedback">
            <mat-option value="suggestion">{{ 'feedbackDialog.suggestion' | transloco }}</mat-option>
            <mat-option value="bug">{{ 'feedbackDialog.bug' | transloco }}</mat-option>
            <mat-option value="opinion">{{ 'feedbackDialog.opinion' | transloco }}</mat-option>
            <mat-option value="other">{{ 'feedbackDialog.other' | transloco }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="w-full">
          <mat-label>{{ 'feedbackDialog.message' | transloco }}</mat-label>
          <textarea
            matInput
            [(ngModel)]="message"
            rows="5"
            maxlength="2000"
            [placeholder]="'feedbackDialog.placeholder' | transloco"
          ></textarea>
          <mat-hint align="end">{{ message.length }}/2000</mat-hint>
        </mat-form-field>
      } @else {
        <div class="text-center py-6">
          <mat-icon class="text-green-500" style="font-size: 48px; width: 48px; height: 48px;">check_circle</mat-icon>
          <p class="mt-4 text-lg font-medium">{{ 'feedbackDialog.thanks' | transloco }}</p>
          <p class="text-secondary text-sm mt-1">{{ 'feedbackDialog.review' | transloco }}</p>
        </div>
      }
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      @if (!submitted) {
        <button mat-button mat-dialog-close>{{ 'common.cancel' | transloco }}</button>
        <button
          mat-flat-button
          color="primary"
          [disabled]="!message.trim() || sending"
          (click)="send()"
        >
          @if (sending) {
            <mat-progress-spinner [diameter]="20" mode="indeterminate"></mat-progress-spinner>
          } @else {
            {{ 'feedbackDialog.send' | transloco }}
          }
        </button>
      } @else {
        <button mat-flat-button color="primary" mat-dialog-close>{{ 'common.close' | transloco }}</button>
      }
    </mat-dialog-actions>
  `,
})
export class FeedbackDialogComponent {
  typeFeedback = 'suggestion';
  message = '';
  sending = false;
  submitted = false;

  constructor(
    private _dialogRef: MatDialogRef<FeedbackDialogComponent>,
    private _feedbackService: FeedbackService,
  ) {}

  send(): void {
    if (!this.message.trim()) return;
    this.sending = true;

    this._feedbackService.sendFeedback({
      type_feedback: this.typeFeedback,
      des_feedback: this.message.trim(),
    }).subscribe({
      next: () => {
        this.sending = false;
        this.submitted = true;
      },
      error: () => {
        this.sending = false;
      }
    });
  }
}
